import React, { useEffect, useContext } from "react";
import { useThemeMode } from "./ThemeContext";
import UserContext from "../assets/user_context";
import { doc, updateDoc } from "firebase/firestore";

/**
 * ThemeUserSync - Syncs theme preferences between ThemeContext and user data
 * Must be placed inside UserProvider to access both contexts
 */
const ThemeUserSync = () => {
  const { themeMode, setThemeModeState, setUserSaveFunction } = useThemeMode();
  const { user, userData, authHook } = useContext(UserContext);

  // Create Firestore save function
  const saveThemeToFirestore = async (newThemeMode) => {
    console.log(
      "📱 [ThemeUserSync] Saving theme mode to Firestore:",
      newThemeMode,
    );

    if (user && authHook?.db) {
      await updateDoc(doc(authHook.db, "users", user.uid), {
        themeMode: newThemeMode,
      });
      console.log(
        "📱 [ThemeUserSync] Theme preference saved to Firestore successfully",
      );
    } else {
      throw new Error("No user or database available");
    }
  };

  // Set/unset the Firestore save function based on user availability
  useEffect(() => {
    if (user && authHook?.db) {
      console.log(
        "📱 [ThemeUserSync] User available, setting Firestore save function",
      );
      setUserSaveFunction(() => saveThemeToFirestore);
    } else {
      console.log(
        "📱 [ThemeUserSync] No user available, clearing save function",
      );
      setUserSaveFunction(null);
    }
  }, [user, authHook?.db, setUserSaveFunction]);

  // Load theme preference from user data when it becomes available
  useEffect(() => {
    if (userData && userData.themeMode && userData.themeMode !== themeMode) {
      console.log(
        "📱 [ThemeUserSync] Loading theme preference from user data:",
        userData.themeMode,
        "current:",
        themeMode,
      );
      setThemeModeState(userData.themeMode);
    }
  }, [userData, themeMode, setThemeModeState]);

  return null; // This component doesn't render anything
};

export default ThemeUserSync;
